import { Check } from "lucide-react";

// Green frame + check badge shown for a moment when a code was decoded.
export function ScanSuccessFlash({ show, rounded = "rounded-3xl", testId = "scan-success-flash" }) {
  if (!show) return null;
  return (
    <div
      className={`pointer-events-none absolute inset-0 ${rounded} ring-[6px] ring-inset ring-emerald-400 bg-emerald-400/15 flex items-center justify-center animate-in fade-in zoom-in-95 duration-150`}
      data-testid={testId}
      aria-live="polite"
    >
      <span className="h-16 w-16 rounded-full bg-emerald-500 text-white shadow-lg flex items-center justify-center">
        <Check className="h-9 w-9" strokeWidth={3} />
      </span>
    </div>
  );
}

export default ScanSuccessFlash;
